(function ($) {
    
    function arrowClicks(){
        $('.nav-menu a').on('click',function(e) {
            
            var href = $(this).attr('href');
            
            if (href === '#' && $(this).parent().hasClass('menu-item-has-children')){
                e.preventDefault();
                $( this ).siblings('.sub-menu').addClass('active');
                $( this ).closest('.menu-item').addClass('open');
                $( this ).parent().siblings('.menu-item').addClass('hidden');
            }
        });
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $( this ).next().addClass('active');
            $( this ).closest('.menu-item').addClass('open');
            $( this ).parent().siblings('.menu-item').addClass('hidden');
            $( this ).closest('.sub-menu').addClass('parent');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
            $( '#' + menuCloseId ).removeClass('active');
            $( '#' + menuCloseId ).parents('.sub-menu').removeClass('parent');
            $( this ).closest('.menu-item').removeClass('open');
            
            $( this ).parent().closest('.menu-item').siblings('.menu-item').removeClass('hidden');
        });
    }
    
    function stickyNav(){
        var $scrollTop = $(window).scrollTop();
        
		if ($scrollTop > 100) { //80 + 57
			$('#masthead').addClass('sticky');
		} else {
			$('#masthead').removeClass('sticky');
		}
	};

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
            anchorPlacement: 'top-bottom'
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'), {
            disableParallax: /iPhone|iPod|Android/,
        });

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                sidrHtml += '<div class="sidr__inner">';
                sidrHtml += '<div class="sidr__mainnav">';
                sidrHtml += '<ul class="nav-menu">';
                    
                if($('.main-navigation').length){
                    sidrHtml += $('.main-navigation .nav-menu').html();
                }
                
                sidrHtml += '</ul>';
                sidrHtml += '</div>';
                
                if($('#safe_exit').length || $('#siteheader_volunteer').length || $('#site-header-donate').length || $('.site-header-subnav .wpml-ls').length){
                    sidrHtml += '<div class="sidr__subnav">';

                    if($('#site-header-donate').length){
                        var visitUrl = $('#site-header-donate').attr('href');
                        sidrHtml += '<a href="' + visitUrl + '" class="button button-primary-default" id="sidr__donate">' +  $('#site-header-donate').html() + '</a>';
                    }
                    if($('#safe_exit').length || $('#siteheader_volunteer').length || $('#siteheader_advocate').length){
                        sidrHtml += '<ul class="sidr__subnav--links">';
                        
                        if($('#safe_exit').length){
                            sidrHtml += '<li>' + $('#safe_exit').html() + '</li>';
                        }
                        if($('#siteheader_advocate').length){
                            sidrHtml += '<li>' + $('#siteheader_advocate').html() + '</li>';
                        }
                        if($('#siteheader_volunteer').length){
                            sidrHtml += '<li>' + $('#siteheader_volunteer').html() + '</li>';
                        }
//                    siteheader_volunteer
                        sidrHtml += '</ul>';
                    }
                    
                    if($('.site-header-subnav .wpml-ls').length){
                        sidrHtml += '<div class="wpml-ls wpml-ls-legacy-list-horizontal">' + $('.site-header-subnav .wpml-ls').html() + '</div>';
                    }
                    sidrHtml += '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                var headerHeight = $("#masthead").height(),
                    windowHeight = $(window).height();
                
                $('#mobile-trigger').addClass('active');
                $('#masthead').addClass('mobile');
                
//                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
                
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '">' + parentText + '</li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $('#mobile-trigger').removeClass('active');
//                $( '.sidr-overlay' ).remove();
                $('#masthead').removeClass('mobile');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });
        
        
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
        $( '.js-modal-popup' ).magnificPopup({
            type: 'inline',
            preloader: false
        });
	});
    
    $(document).on("mousedown touchstart",function(event){
        if($(event.target).closest('#sitesearch--toggle').length && $(event.target).is('#sitesearch--toggle')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#sitesearch--close').length && $(event.target).is('#sitesearch--close')) {
            $('#sitesearch').removeClass('active');
        }
        if($(event.target).closest('#sitesearch.active').length && $(event.target).is('#sitesearch.active')) {
            $("#sitesearch").removeClass('active');
        } 
    });
    
    //on resize
//    $(window).on('resize', function(){
//        AOS.refresh();
//    });
//    $("#page").on('scroll', function () {
//        AOS.refresh();
//    });
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
    });

    
})(jQuery);